import { NgModule } from '@angular/core';
import { RouterModule, Route } from '@angular/router';
import { OktaAuthGuard, OktaAuthModule, OktaCallbackComponent } from '@okta/okta-angular';

import {
	ClaimInvalidUrlRouteComponent,
	ClaimRedirectRouteComponent
} from '@shure/cloud/device-management/devices/feature-add-devices';
import { maintenanceGuard } from '@shure/cloud/shared/maintenance/utils';
import { oktaSessionGuard } from '@shure/cloud/shared/okta/data-access';
import { SigninGuard, SignInComponent } from '@shure/cloud/shared/okta/feature-okta-signin';
import { initializeFeatureFlagsGuard } from '@shure/cloud/shared/utils/feature-flags';
import { importTranslations } from '@shure/shared/angular/utils/i18n';

import { AppShellComponent } from '../components/app-shell/app-shell.component';
import { AccountGuard } from '../guards/account.guard';

const appRoutes: Route[] = [
	{
		path: 'signin',
		component: SignInComponent,
		canActivate: [SigninGuard]
	},
	{
		path: 'signin/callback',
		component: OktaCallbackComponent
	},
	{
		path: 'maintenance',
		loadChildren: () =>
			import('@shure/cloud/shared/maintenance/feature-maintenance')
				.then((m) => m.MaintenanceModule)
				.then(importTranslations),
		canActivate: [maintenanceGuard('maintenanceRoute', 'devices'), oktaSessionGuard]
	},
	{
		path: '',
		component: AppShellComponent,
		canActivateChild: [
			maintenanceGuard('nonMaintenanceRoute', 'maintenance'),
			OktaAuthGuard,
			oktaSessionGuard,
			initializeFeatureFlagsGuard({ setUserConfig: true }),
			AccountGuard
		],
		children: [
			{
				path: 'claim',
				children: [
					{
						path: 'v1/:serial/:mac',
						component: ClaimRedirectRouteComponent
					},
					{
						path: 'v2/:model/:serial/:mac',
						component: ClaimRedirectRouteComponent
					},
					{
						path: '**',
						component: ClaimInvalidUrlRouteComponent
					}
				]
			},
			{
				path: 'devices',
				loadChildren: () =>
					import('@shure/cloud/device-management/devices/feature-inventory')
						.then((m) => m.InventoryMainModule)
						.then(importTranslations)
			},
			{
				path: 'pending-devices',
				loadChildren: () =>
					import('@shure/cloud/device-management/devices/feature-pending')
						.then((m) => m.PendingDevicesModule)
						.then(importTranslations)
			},
			{
				path: '**',
				redirectTo: 'devices',
				pathMatch: 'full'
			}
		]
	},
	// ** is the "page not found" route.
	// Try to go to /devices. If the user isn't logged in, the auth guard
	// will redirect them to the Signin Page.
	{
		path: '**',
		redirectTo: 'devices',
		pathMatch: 'full'
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(appRoutes, {
			initialNavigation: 'enabledBlocking',
			useHash: false, // must be false for okta signin/callback to route.
			bindToComponentInputs: true
		}),
		OktaAuthModule
	],
	exports: [RouterModule]
})
export class AppRoutingModule {}
